module.exports = __webpack_public_path__ + "img/hampton-tuscaloosa-east-logo.02d46638.jpg";